// extracted by mini-css-extract-plugin
module.exports = {"category":"_3Ax2Go"};